import * as actions from '@/constants/actions';
import * as mutations from '@/constants/mutations';

export default {
    state: {
        // sidebar component visibility
        show: false,
        // sidebar context mode:
        // - 'live' = live list of (filtered) stations on the map
        // - 'station' = single station info
        // - 'watershed' = single watershed info
        // - 'licence' = single water licence info
        context: 'live',
    },
    mutations: {
        /**
         * change sidebar visibility
         * @param {Object}  state       vuex state
         * @param {Boolean} [show=true] true to show sidebar
         */
        [mutations.SHOW_MAP_SIDEBAR](state, show = true) {
            state.show = show;
        },
        /**
         * change sidebar display context
         * @see state.context above
         * @param {Object} state   vuex state
         * @param {String} context sidebar display context
         */
        [mutations.SET_SIDEBAR_CONTEXT](state, context) {
            state.context = context;
        },
    },
    actions: {
        /**
         * change sidebar visibility
         */
        [actions.SHOW_MAP_SIDEBAR]({ commit }, show) {
            commit(mutations.SHOW_MAP_SIDEBAR, show);
        },
        /**
         * change sidebar display context
         */
        [actions.SET_SIDEBAR_CONTEXT]({ commit }, context) {
            commit(mutations.SET_SIDEBAR_CONTEXT, context);
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/SidebarModule.js